import { ComponentPropsWithoutRef } from 'react';

export function TopLines(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="283" height="299" viewBox="0 0 283 299" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g opacity="0.8">
        <path
          d="M240.514 286.593L70.4785 116.558L-84.4423 116.558L-179.221 21.7788M-274 -73L-179.221 21.7788M120.859 -59.775L203.358 22.7234L203.358 116.558L269.482 182.682M-179.221 21.7788L76.7761 21.7788L132.195 77.1976"
          stroke="#8071B0"
        />
        <circle cx="243.84" cy="291.33" r="7.6701" transform="rotate(90 243.84 291.33)" fill="#9D91C4" />
        <circle cx="132.195" cy="77.5124" r="3.77856" transform="rotate(90 132.195 77.5124)" fill="#8071B0" />
        <circle cx="274.52" cy="187.784" r="7.6701" transform="rotate(90 274.52 187.784)" fill="#9D91C4" />
        <path
          d="M-11.3907 177.013L-11.8907 177.013L-11.8907 177.22L-11.7443 177.367L-11.3907 177.013ZM55.3638 241.101C53.891 241.101 52.6971 242.295 52.6971 243.768C52.6971 245.241 53.891 246.434 55.3638 246.434C56.8365 246.434 58.0304 245.241 58.0304 243.768C58.0304 242.295 56.8365 241.101 55.3638 241.101ZM-11.8907 117.816L-11.8907 177.013L-10.8907 177.013L-10.8907 117.816L-11.8907 117.816ZM-11.7443 177.367L55.0102 244.121L55.7173 243.414L-11.0372 176.66L-11.7443 177.367Z"
          fill="#8071B0"
        />
      </g>
    </svg>
  );
}

export function BottomLines(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="580" height="373" viewBox="0 0 580 373" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g opacity="0.8">
        <path
          d="M41.6764 12.4074L211.711 182.442L366.632 182.442L461.411 277.221M556.19 372L461.411 277.221M161.331 358.775L78.8322 276.277L78.8322 182.442L12.7075 116.318M461.411 277.221L205.414 277.221L149.995 221.802"
          stroke="#8071B0"
        />
        <circle cx="38.3503" cy="7.67072" r="7.6701" transform="rotate(-90 38.3503 7.67072)" fill="#9D91C4" />
        <circle cx="149.995" cy="221.487" r="3.77856" transform="rotate(-90 149.995 221.487)" fill="#8071B0" />
        <circle cx="7.6701" cy="111.216" r="7.6701" transform="rotate(-90 7.6701 111.216)" fill="#9D91C4" />
        <path
          d="M293.581 121.987L294.081 121.987L294.081 121.78L293.934 121.634L293.581 121.987ZM226.826 57.8994C228.299 57.8994 229.493 56.7055 229.493 55.2327C229.493 53.7599 228.299 52.566 226.826 52.566C225.353 52.566 224.159 53.7599 224.159 55.2327C224.159 56.7055 225.353 57.8994 226.826 57.8994ZM294.081 181.185L294.081 121.987L293.081 121.987L293.081 181.185L294.081 181.185ZM293.934 121.634L227.18 54.8791L226.473 55.5863L293.227 122.341L293.934 121.634Z"
          fill="#8071B0"
        />
      </g>
    </svg>
  );
}
